import { versionedHttpCollection } from "us.helper/http/collection";
import ServiceConfig from "service.config.js";
import {
  IExecuteRequest,
  IGetTemplateReq,
  ISendEmailReq,
} from "us.collection.case/components/MessageTemplates/Interface";
import { IMessageTemplatePatchData } from "us.collection.case/interfaces";

export default {
  getAll: <
    P extends {
      entityType: string;
    }
  >(
    params: P
  ): Promise<any> => {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data } = await versionedHttpCollection.get(
          "uscservice",
          `templatelist/${params.entityType}`,
          {},
          ServiceConfig()[`uscservice`]["templatelist"]
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  delete: <P extends { templateId: string | number }>(
    params: P
  ): Promise<any> => {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data } = await versionedHttpCollection.delete(
          "uscservice",
          "templatelist",
          params.templateId,
          {},
          ServiceConfig()[`uscservice`]["templatelist"]
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getById: (params: IGetTemplateReq): Promise<any> => {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data } = await versionedHttpCollection.post(
          "uscservice",
          "templatecontent",
          { ...params },
          ServiceConfig()[`uscservice`]["templatecontent"]
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  excuteActivity: (params: IExecuteRequest): Promise<any> => {
    const {
      communicationJobId,
      entityId,
      entityType,
      templateName,
      templateCategory,
      pluginName,
      htmlContent,
      activityVersion,
    } = params;
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data } = await versionedHttpCollection.post(
          "uscservice",
          "messagetemplate",
          {
            communicationJobId,
            entityId,
            entityType,
            templateName,
            templateCategory,
            pluginName,
            htmlContent,
            activityVersion
          },
          ServiceConfig()[`uscservice`]["messagetemplate"]
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  sendEmail: (params: ISendEmailReq): Promise<any> => {
    const {
      entityId,
      entityType,
      communicationJobId,
      mesageContent,
      emailOrTelNo,
      isPaymentInfoSMS,
      isGiroDocument,
      dueDate,
      senderType,
      messgeType,
      attachmentPaths,
      documentType,
      subject,
    } = params;
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data } = await versionedHttpCollection.post(
          "uscservice",
          "messages",
          {
            entityId,
            entityType,
            communicationJobId,
            mesageContent,
            emailOrTelNo,
            isPaymentInfoSMS,
            isGiroDocument,
            dueDate,
            senderType,
            messgeType,
            attachmentPaths,
            documentType,
            subject,
          },
          ServiceConfig()[`uscservice`]["messages"]
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  pinUnpinMessageTemplate: (
    params: IMessageTemplatePatchData | any
  ): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        let templateLists;
        const { data } = await versionedHttpCollection.patch(
          "uscservice",
          `templatelist/${params.templateId}`,
          params.pinStatusObject,
          ServiceConfig()[`uscservice`]["templatelist"]
        );

        if (!data.isError) {
          templateLists = await versionedHttpCollection.get(
            "uscservice",
            `templatelist/${params.entityType}`,
            {},
            ServiceConfig()[`uscservice`]["templatelist"]
          );
        }
        resolve({ data, templateLists });
      } catch (error) {
        reject(error);
      }
    });
  },
  updateDisplayName: (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { id, newDisplayName } = params ?? {};
        const { data: response, status } = await versionedHttpCollection.put(
          "uscservice",
          `template/${id}/${newDisplayName}`,
          {},
          "v1"
        );
        resolve({ response, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  getMessageContent: (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.post(
          "activityservice",
          `messagetemplate/content`,
          params,
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  email: (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.post(
          "activityservice",
          `messagetemplate/message`,
          params,
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  bmd: (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.post(
          "bmdservice",
          `bmdkeyvalue`,
          params,
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
};
